import { apiPost } from 'api';
import { EmptyObject } from 'types';
import { AssignConsulteeRequest } from '../../types';

export const assignConsultee = (request: AssignConsulteeRequest): Promise<EmptyObject> =>
  apiPost<EmptyObject, AssignConsulteeRequest>('consultations/updateconsultee', request);
